import { IApiSettings, IHttpRequest } from  '@/interfaces/IHttp';
import React, { MutableRefObject, useState } from 'react'
import { BuildPath } from '../../../helpers/Paths'
import { container, TYPES } from '../../../inversifyconfig/container.config'
import { UserUploadStage } from '../../../models/ApiResponseModels/UserUploadHistoryResponseModel'
import MiniModal  from '../../modals/MiniModal'; 

interface ViewDetialsProps {
    id: number
    setRefresh: (value: boolean) => void
    status: UserUploadStage
    isInFlight:boolean
    fileName: string
    cancelOrCompleteRef: MutableRefObject<{[key: number]: "cancel" | "complete"}>
}

const ViewDetails = ({id, status, isInFlight, fileName, cancelOrCompleteRef, setRefresh }: ViewDetialsProps) => {

    const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);
    const [modalOpen, setModalOpen] = useState<boolean>(false);

    function closeModal () {
        setRefresh(true);
        setModalOpen(false);
    }

    switch(status) {
        case UserUploadStage.Completed:
            return <a href={`/api/UserImport/DownloadComparisonFile/${id}`} target="blank">Download Change Log</a>;
            

        case UserUploadStage.Comparing:
            return isInFlight
                ? null
                : <>
                    {
                    modalOpen && 
                        <MiniModal 
                            title="Resume Bulk User Upload"
                            showModal={modalOpen}
                            confirmLabel='Apply Changes and Complete Upload'
                            className='confirm-user-upload'
                            cancelLabel='Abandon Upload'
                            onCancel={() => {
                                cancelOrCompleteRef.current[id] = 'cancel';
                                httpCall.post(`/UserImport/Cancel/${id}`, null)
                                    .catch(() => delete cancelOrCompleteRef.current[id])
                                    .finally(closeModal);
                            }}
                            onConfirm={() => {
                                cancelOrCompleteRef.current[id] = 'complete';
                                httpCall.post(`/UserImport/Complete/${id}`, null)
                                    .catch(() => delete cancelOrCompleteRef.current[id])
                                    .finally(closeModal);
                            }}
                            onClose={closeModal}
                        >
                        <div className="resume-user-upload-modal-contents">    
                            <p className="filename">File Name</p>
                            <p className="body-text">{fileName}'s Upload was interupted</p>
                            <p className="body-text">This upload was not completed, please consult the changelog below and then apply or abandon the changes.</p>
                            <a className="body-text" href={`/api/UserImport/DownloadComparisonFile/${id}`} target="blank">Download Change Log</a>
                        </div>
                        </MiniModal>
                    }
                    <button className="btn user-upload-btn-link" onClick={() => {setModalOpen(true)}}>Approve or Reject Changes</button>
                </>      
        case UserUploadStage.Failed: 
            return (
                <a href={`/api/UserImport/DownloadValidationErrorFile/${id}`} target="blank">Download Error Log</a>
            )
        default:
            return null;
    }           
}

export default ViewDetails;